import { ArrowUpRight, Compass, FileCheck2, Grid3X3, HardHat, Plug, Waves } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink } from "../lib/constants";

const SERVICES = [
  {
    icon: Compass,
    title: "Projeto Arquitetônico",
    text: "Estudo preliminar, anteprojeto e executivo com plantas, cortes, fachadas e imagens 3D realistas do seu imóvel.",
  },
  {
    icon: Grid3X3,
    title: "Projeto Estrutural",
    text: "Dimensionamento em concreto armado, metálico ou alvenaria estrutural, com detalhamento de fôrmas e armaduras.",
  },
  {
    icon: Plug,
    title: "Projeto Elétrico",
    text: "Instalações elétricas, SPDA, iluminação e cabeamento, conforme NBR 5410 e padrão da concessionária.",
  },
  {
    icon: Waves,
    title: "Projeto Hidrossanitário",
    text: "Água fria e quente, esgoto, águas pluviais e reúso, com detalhamento isométrico e memorial de cálculo.",
  },
  {
    icon: FileCheck2,
    title: "Regularização e Aprovação",
    text: "Aprovação em Prefeitura, alvará, habite-se, averbação e emissão de RRT/ART de responsabilidade técnica.",
  },
  {
    icon: HardHat,
    title: "Acompanhamento de Obra",
    text: "Visitas técnicas, compatibilização de projetos, orçamento e cronograma para a obra seguir o que foi desenhado.",
  },
];

export const ServicesSection = () => (
  <section id="servicos" data-testid="services-section" className="scroll-mt-24 bg-slate-950 text-white">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-20">
      <Reveal className="lg:sticky lg:top-28 lg:self-start">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#C05621]">Serviços</p>
        <h2 className="font-display mt-4 text-3xl font-extrabold uppercase leading-[1.02] tracking-tight sm:text-4xl lg:text-5xl">
          Do primeiro traço ao habite-se
        </h2>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
          Disciplinas integradas em um único escritório: o que é desenhado na arquitetura
          já nasce compatível com estrutura, elétrica e hidráulica — e aprovado na prefeitura.
        </p>
        <a
          data-testid="services-whatsapp-button"
          href={waLink("Olá! Gostaria de um orçamento para projeto com a ZARI ENGENHARIA.")}
          target="_blank"
          rel="noreferrer"
          className="mt-10 inline-flex items-center gap-3 border border-white/20 px-7 py-4 font-mono text-xs uppercase tracking-[0.2em] text-white transition-colors hover:border-[#C05621] hover:bg-[#C05621]"
        >
          Solicitar orçamento <ArrowUpRight size={15} />
        </a>
      </Reveal>

      <ol className="divide-y divide-white/10 border-y border-white/10">
        {SERVICES.map(({ icon: Icon, title, text }, i) => (
          <Reveal key={title} delay={i * 0.06}>
            <li data-testid={`service-item-${i + 1}`} className="group grid gap-4 py-7 sm:grid-cols-[56px_1fr_40px] sm:gap-8">
              <span className="font-mono text-xs text-slate-500 transition-colors group-hover:text-[#C05621]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="font-display text-lg font-bold uppercase tracking-tight sm:text-xl">{title}</h3>
                <p className="mt-2 max-w-lg text-sm leading-relaxed text-slate-400">{text}</p>
              </div>
              <Icon
                size={22}
                strokeWidth={1.4}
                className="hidden text-slate-600 transition-all duration-300 group-hover:-translate-y-1 group-hover:text-[#C05621] sm:block"
              />
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
